module.exports = __webpack_public_path__ + "img/details-magnifier.32d37f69.svg";